import {observer} from "mobx-react-lite";
import GameTeam from "./../../Games/GameTeam";
import {useParams} from "react-router";
import {useEffect} from "react";
import clubStore from "../../../storage/ClubStore";

const EditGameTeam = () => {
    const args = useParams()
    useEffect(() => {
        if (args.id) {
            clubStore.tournament.getGameTeam(args.id)
        }
    }, [args.id])
    return (
        <GameTeam role={'MGR'}/>
    )
}

export default observer(EditGameTeam)